var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "OPENID：",
      "label-width": "70px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.openId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "openId", $$v);
      },
      expression: "searchInfo.openId"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "角色ID：",
      "label-width": "70px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.roleId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "roleId", $$v);
      },
      expression: "searchInfo.roleId"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "角色名：",
      "label-width": "70px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.roleName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "roleName", $$v);
      },
      expression: "searchInfo.roleName"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "关卡ID：",
      "label-width": "70px"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "120px",
      height: "38px"
    },
    attrs: {
      controls: false
    },
    model: {
      value: _vm.searchInfo.guanqiaNo,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "guanqiaNo", $$v);
      },
      expression: "searchInfo.guanqiaNo"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务器列表："
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1)], 1), _c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期段：",
      "label-width": "70px"
    }
  }, [[_c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.timedata,
      callback: function callback($$v) {
        _vm.timedata = $$v;
      },
      expression: "timedata"
    }
  })]], 2), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.queryEvent("search");
            }
          }
        }, [_vm._v("查询")])];
      },
      proxy: true
    }])
  })], 1), _c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "区服",
      prop: "server_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverList[scope.row.server_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "OPEN ID",
      prop: "open_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "角色ID",
      prop: "role_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "角色名",
      prop: "role_name"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "角色等级",
      prop: "role_level"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "VIP等级",
      prop: "role_vip_level"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "战力",
      prop: "score"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "关卡id",
      prop: "guanqia_no"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "玩法类型",
      prop: "gameplay_type_name"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "结束类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(_vm.getEndType(row)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "关卡结束时间",
      prop: "log_time"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "通关时长",
      prop: "duration"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "使用道具次数",
      prop: "item_times"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };